import TabButton from "../tabButton";
import { dashboardTabs } from "../../../constants/dashboardLayoutData";
import { getCookies } from "cookies-next";

function Tabs() {
  const { mage } = getCookies("mage");

  return (
    <div className="flex items-center overflow-x-auto overflow-y-hidden gap-4 mb-4">
      {dashboardTabs?.map(
        (item, key) =>
          (mage || key == 3) && (
            <TabButton
              key={key}
              icon={item.icon}
              label={item.label}
              target={item.target}
            />
          )
      )}
    </div>
  );
}

export default Tabs;
